<template>
  <b-form class="mt-3" @submit="onSubmitForm">
    <b-row
      v-if="
        props.mode == 'Screening' ||
          props.mode == 'ScreeningHistory' ||
          props.mode == 'Deptlist' ||
          props.mode == 'History' ||
          props.mode == 'LawDeptlist' ||
          props.mode == 'Officer' ||
          props.mode == 'LawOfficer' ||
          props.mode == 'UserHistory' ||
          props.mode == 'LawLeaderDept'
        
      "
    >
      <b-col cols="12" md="6">
        <InputFilter :filter="search[0]" />
      </b-col>
      <b-col cols="12" md="6">
        <InputFilter :filter="search[1]" />
      </b-col>

      <b-col cols="12" md="6">
        <InputFilter :filter="search[2]" />
      </b-col>
      <b-col cols="12" md="3">
        <InputFilter :filter="search[3]" />
      </b-col>
      <b-col cols="12" md="3">
        <InputFilter :filter="search[4]" />
      </b-col>

      <b-col cols="12" md="6">
        <InputFilter :filter="search[5]" />
      </b-col>
    </b-row>
    <b-row v-else-if="props.mode == 'ScreeningGroup'"> 
      <b-col cols="12" md="6">
        <InputFilter :filter="search[0]" />
      </b-col>
      <b-col cols="12" md="6">
        <InputFilter :filter="search[1]" />
      </b-col>

      <b-col cols="12" md="6">
        <InputFilter :filter="search[2]" />
      </b-col>
      <b-col cols="12" md="3">
        <InputFilter :filter="search[3]" />
      </b-col>
      <b-col cols="12" md="3">
        <InputFilter :filter="search[4]" />
      </b-col>

      <b-col cols="12" md="6">
        <InputFilter :filter="search[5]" />
      </b-col>
    </b-row>
    <b-row v-else-if="props.mode == 'UserGroup'">
      <b-col cols="12" md="6">
        <InputFilter :filter="search[0]" />
      </b-col>
      <b-col cols="12" md="6">
        <InputFilter :filter="search[1]" />
      </b-col>

      <b-col cols="12" md="6">
        <InputFilter :filter="search[2]" />
      </b-col>
      <b-col cols="12" md="3">
        <InputFilter :filter="search[3]" />
      </b-col>
      <b-col cols="12" md="3">
        <InputFilter :filter="search[4]" />
      </b-col>

      <b-col cols="12" md="6">
        <InputFilter :filter="search[5]" />
      </b-col>
    </b-row>
    <b-row v-else-if="props.mode == 'SearchAll'">
      <b-col cols="12" md="6">
        <InputFilter :filter="search[0]" />
      </b-col>
      <b-col cols="12" md="6">
        <InputFilter :filter="search[1]" />
      </b-col>

      <b-col cols="12" md="6">
        <InputFilter :filter="search[2]" />
      </b-col>
      <b-col cols="12" md="3">
        <InputFilter :filter="search[3]" />
      </b-col>
      <b-col cols="12" md="3">
        <InputFilter :filter="search[4]" />
      </b-col>

      <b-col cols="12" md="6">
        <InputFilter :filter="search[5]" />
      </b-col>

      <b-col cols="12" md="3">
        <b-form-group
          label="สถานะความคืบหน้า"
          label-for="status"
        >
          <v-select
            label="text"
            :options="statuses"
            v-model="status"
            placeholder="กรุณาเลือกข้อมูล"
            @input="selectOnInput"
          /> 
        </b-form-group>
      </b-col>

      <b-col cols="12" md="3">
        <b-form-group
          label="หน่วยงานที่รับผิดชอบ"
          label-for="departmentId"
        >
          <v-select
            label="text"
            :options="departments"
            v-model="departmentId"
            placeholder="กรุณาเลือกข้อมูล"
            @input="selectOnInput"
          /> 
        </b-form-group>
      </b-col>
    </b-row>
    <!-- Action Buttons -->
    <div class="text-center pt-1">
      <b-button
        variant="primary"
        class="mb-1 mb-sm-0 mr-0 mr-sm-1"
        type="submit"
      >
        ค้นหา
      </b-button>
      <b-button
        variant="outline-secondary"
        type="reset"
        @click="onResetBtnClicked"
      >
        ล้าง
      </b-button>
    </div>
  </b-form>
</template>

<script>
import {
  BButton,
  BAvatar,
  BRow,
  BCol,
  BFormGroup,
  BFormInput,
  BForm,
  BFormCheckbox,
} from "bootstrap-vue";
import vSelect from "vue-select";
import InputFilter from "../../../filters/components/InputFilter.vue";
import * as storeMaster from "@/store/api/master/index.js";
import * as storeStatus from "@/store/api/status/index.js";

export default {
  components: {
    BButton,
    BAvatar,
    BRow,
    BCol,
    BFormGroup,
    BFormInput,
    BForm,
    BFormCheckbox,
    vSelect,
    InputFilter,
  },
  props: {
    mode: {
      type: String,
      required: true,
    },
    autoSearch: {
      type: Boolean,
      default: true,
    },
  },
  setup(props) {
    const departments = [];
    const statuses = [];
    const searchList = [
      {
        id: "receiveCode",
        label: "เลขรับแจ้ง / เลขสารบัญ / รหัสติดตามเรื่องหน่วยงานภายนอก",
        value: "",
        class: "",
        style: "",
        placeholder:
          "กรอกเลขรับแจ้ง / เลขสารบัญ / รหัสติดตามเรื่องหน่วยงานภายนอก",
        type: "text",
        options: [],
      },
      {
        id: "attorneySearch",
        label: "ข้อมูลผู้ร้องทุกข์ / ผู้มอบอำนาจ (ชื่อ-นามสกุล/เลขบัตรประชาชน)",
        value: "",
        class: "",
        style: "",
        placeholder: "กรอกข้อมูลผู้ร้องทุกข์ / ผู้มอบอำนาจ",
        type: "text",
        options: [],
      },
      {
        id: "companySearch",
        label:
          "ข้อมูลผู้ถูกร้องทุกข์ / ผู้ประกอบการ  (ชื่อผู้ประกอบการ / เลขนิติบุคคล)",
        value: "",
        class: "",
        style: "",
        placeholder:
          "กรอกข้อมูลผู้ถูกร้องทุกข์ / ผู้ประกอบการ  (ชื่อผู้ประกอบการ / เลขนิติบุคคล)",
        type: "text",
        options: [],
      },
      {
        id: "startdateSearch",
        label: "ช่วงเวลาที่ร้องทุกข์",
        value: "",
        class: "",
        style: "",
        placeholder: "จากวันที่",
        type: "date",
        options: [],
      },
      {
        id: "enddateSearch",
        label: "ถึง",
        value: "",
        class: "",
        style: "",
        placeholder: "ถึงวันที่",
        type: "date",
        options: [],
      },
      {
        id: "complainDetail",
        label: "รายละเอียดเรื่องร้องทุกข์",
        value: "",
        class: "",
        style: "",
        placeholder: "รายละเอียดเรื่องร้องทุกข์",
        type: "text",
        options: [],
      },
      {
        id: "status",
        label: "สถานะความคืบหน้า",
        value: "",
        class: "",
        style: "",
        placeholder: "กรุณาเลือกสถานะความคืบหน้า",
        type: "bselect",
        options: statuses,
      },
      {
        id: "departmentId",
        label: "หน่วยงานที่รับผิดชอบ",
        value: "",
        class: "",
        style: "",
        placeholder: "กรุณาเลือกหน่วยงานที่รับผิดชอบ",
        type: "bselect",
        options: departments,
      },
    ];
    return {
      search: searchList,
      props,
      departments,
      departmentId: null,
      statuses,
      status: null,
    };
  },
  mounted() {
    console.log("this.props", this.props.mode, this.props.autoSearch);
    if (this.props.autoSearch == true) {
      this.onSearchBtnClicked();
    }
    this.getDepartmentDropdown();
    this.getStatusDropdown();
  },
  methods: {
    onSubmitForm(e) {
      e.preventDefault();
      this.onSearchBtnClicked();
    },
    onResetBtnClicked() {
      if (
        this.props.mode === "Screening" ||
        this.props.mode === "ScreeningHistory" ||
        this.props.mode == "Deptlist" ||
        this.props.mode == "LawDeptlist" ||
        this.props.mode == "Officer" ||
        this.props.mode == "LawOfficer" ||
        this.props.mode == "History" ||
        this.props.mode == "UserHistory" ||
        this.props.mode == "LawLeaderDept" ||
        this.props.mode == "SearchAll"
      ) {
        this.search[0].value = null;
        this.search[1].value = null;
        this.search[2].value = null;
        this.search[3].value = null;
        this.search[4].value = null;
        this.search[5].value = null;
        this.status = null;
        this.departmentId = null;
      } else if (this.props.mode == "ScreeningGroup") {
        this.search[0].value = null;
        this.search[1].value = null;
        this.search[2].value = null;
        this.search[3].value = null;
        this.search[4].value = null;
        this.search[5].value = null;
      }
    },
    onSearchBtnClicked() {
      if (
        this.props.mode === "Screening" ||
        this.props.mode === "ScreeningHistory" ||
        this.props.mode == "Deptlist" ||
        this.props.mode == "LawDeptlist" ||
        this.props.mode == "Officer" ||
        this.props.mode == "LawOfficer" ||
        this.props.mode == "History" ||
        this.props.mode == "UserHistory" ||
        this.props.mode == "LawLeaderDept" ||
        this.props.mode == "SearchAll"
      ) {
        const params = {
          code: this.search[0].value,
          name: this.search[1].value,
          company: this.search[2].value,
          startDate: this.search[3].value,
          endDate: this.search[4].value,
          value: this.search[5].value,
          status: this.status !== null ? this.status.value : "",
          departmentId: this.departmentId !== null ? this.departmentId.value : "",
          tabName: this.props.mode,
        };

        this.$emit("handleSubmit", params);
      } else if (this.props.mode === "ScreeningGroup") { 
        const params = {
          code: this.search[0].value,
          name: this.search[1].value,
          company: this.search[2].value,
          startDate: this.search[3].value,
          endDate: this.search[4].value,
          value: this.search[5].value,
          tabName: this.props.mode,
        };
        console.log("onSearchBtnClicked - ScreeningGroup", params);
        this.$emit("handleSubmit", params);
      } else if (this.props.mode === "UserGroup") {
        console.log("onSearchBtnClicked - UserGroup");
        const params = {
          code: this.search[0].value,
          name: this.search[1].value,
          company: this.search[2].value,
          startDate: this.search[3].value,
          endDate: this.search[4].value,
          value: this.search[5].value,
          tabName: this.props.mode,
        };
        console.log("onSearchBtnClicked - UserGroup", params);
        this.$emit("handleSubmit", params);
      }
    },
    getDepartmentDropdown() {
      const _this = this;

      storeMaster
        .getDepartment(2)
        .then(function(response) {
          // handle success
          _this.departments = response.data.data;
          console.log("departments", _this.departments);
          _this.$forceUpdate();
        })

        .catch(function(error) {
          // handle error
          console.log("error", error);
        });
    },
    getStatusDropdown() {
      const _this = this;

      storeStatus
        .GetStatusAll()
        .then(function(response) {
          // handle success
          _this.statuses = response.data.data;
          console.log("statuses", _this.statuses);
          _this.$forceUpdate();
        })

        .catch(function(error) {
          // handle error
          console.log("error", error);
        });
    },
    selectOnInput() {
      this.$forceUpdate();
    },
  },
};
</script>
<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
</style>
